<template>
    <div class="flex-row">
        <div class="box-panel flex-row middle">
            <div class="wf">
                <img src="/static/icon/datas.png" alt="" style="width: 80%" />
            </div>
            <div class="flex-column wf2">
                <div class="flex-column list" style="padding: 10px 0 20px 0">
                    <div class="flex-row f20w">已参培人次</div>
                    <div class="flex-row start baseline left list-half">
                        <span class="f32 bold">{{ value || 0 }}</span><span class="f20g">人次</span>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-column wf left list-half" v-for="(item, index) in Data" :key="index">
                        <div class="f16 c-gray">{{ item.Title }}</div>
                        <div class="f24">{{ item.Value || 0 }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Number,
        config: Object,
    },
    data() {
        return {
            Data: [],
            All: 0,
        };
    },
    methods: {
        handleSearch() {
            let datas = [];
            datas.push(
                this.$matrix.AjaxGet3(
                    "Users.Plan",
                    "GetList",
                    { Fields: ["IdCount"], ExamResult: 2 },
                    this.config.Role,
                    this.config.RoleField
                )
            );
            datas.push(
                this.$matrix.AjaxGet3(
                    "Users.Plan",
                    "GetList",
                    { Fields: ["IdCount"], ExamResult: 3 },
                    this.config.Role,
                    this.config.RoleField
                )
            );
            Promise.all(datas)
                .then((data) => {
                    if (data.length) {
                        let Passed = data[0].Items[0] ? data[0].Items[0].IdCount : 0;
                        let NoPassed = data[1].Items[0] ? data[1].Items[0].IdCount : 0;
                        let Rate =
                            this.value === 0
                                ? 0 + "%"
                                : Math.floor(((Passed / this.value) * 10000) / 100) + "%";
                        this.Data = [
                            { Title: "通过人次", Value: Passed },
                            { Title: "未通过人次", Value: NoPassed },
                            { Title: "培训通过率", Value: Rate },
                        ];
                    }
                })
                .catch((e) => {
                    //console.log(e);
                });
        },
        parentStyle() {
            return { height: "240px" };
        },
    },
    created() {
        this.handleSearch();
    },
};
</script>

<style scoped>
.box-panel {
    background-color: #2969ff;
    border-radius: 5px;
    color: #fff;
    width: 100%;
    height: 230px;
}

.wf {
    flex: 1;
}

.wf2 {
    flex: 2;
}

.f32 {
    font-size: 32px;
}

.f30 {
    font-size: 30px;
}

.f28 {
    font-size: 28px;
}

.f26 {
    font-size: 26px;
}

.f24 {
    font-size: 24px;
}

.f22 {
    font-size: 22px;
}

.f20 {
    font-size: 20px;
}

.f16 {
    font-size: 16px;
}

.c-gray {
    color: #fff;
    opacity: 0.6;
}

.baseline {
    display: table-cell;
    vertical-align: bottom;
}
</style>